import React from 'react'
import BusinessLoanForm from './Components/BusinessLoanForm'

const BusinessLoan = () => {

    return (
        <div>
            {/* // x---------------------------------x BusinessLoanForm x---------------------------------x  */}
            <div className="grid bg-body">
                <div className="col-span-full mx-0 px-0">
                    <div className="rounded-lg h-full">
                        <div className="flex justify-between p-4">
                            <h3 className="text-dark sm:text-2xl font-semibold">Apply for a loan</h3>
                        </div>
                        <div className="mb-3 mb-sm-0 card-body rounded-2xl text-dark">
                            <div className="sm:p-6 p-4">
                                {/* // x---------------------------------x BusinessLoanForm Section // x---------------------------------x  */}
                                <BusinessLoanForm />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BusinessLoan